"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.usePrevious = (value) => {
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const reference = react_1.useRef();
    // Store current value in ref
    react_1.useEffect(() => {
        reference.current = value;
    }, [value]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return reference.current;
};
//# sourceMappingURL=use-previous.js.map